import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ReactTable from 'react-table';
import { Button, Header, Icon, Form, Message, Modal, Select, Table, Segment } from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import numeral from 'numeral';
import moment from 'moment';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  requireDecimal: true,
  allowNegative: true
});

const INGRESOS_DEFAULT = [
  {
    nombre: 'Recursos Ley Nacional 23.427',
    monto: 0
  },
  {
    nombre: 'Comisiones por Prestamos Otorgados',
    monto: 0
  },
  {
    nombre: 'Transferencia de INAES',
    monto: 0
  },
  {
    nombre: 'Cobro Tesoreria de la Provincia',
    monto: 0
  },
  {
    nombre: 'Redondeo',
    monto: 0
  }
];

const EGRESOS_DEFAULT = [
  {
    nombre: 'Prestamos y Subsidios pagados',
    monto: 0
  }
];

const INITIAL_STATE = {
  resumenes: {
    loading: false,
    data: [],
    error: null
  },
  cuentas: {
    loading: false,
    data: [],
    error: null
  },
  prestamos: {
    loading: false,
    data: [],
    error: null
  },
  upsertModal: {
    open: false,
    loading: false,
    id: null,
    values: {
      fecha: moment().format('YYYY-MM-DD'),
      cuentas: [],
      ingresos: INGRESOS_DEFAULT,
      recupero: [],
      egresos: EGRESOS_DEFAULT
    }
  },
  removeModal: {
    open: false,
    loading: false,
    record: null,
    error: null
  },
  reportLayout: false,
  resumenAImprimir: null
};

class MensualView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;
    this.CuentaService = this.props.feathers.service('/api/cuentas');
    this.ResumenService = this.props.feathers.service('/api/resumenes-mensuales');
    this.PrestamoService = this.props.feathers.service('/api/prestamos');
  }

  calcultarSaldo = (transacciones, plain = false) => {
    let saldo = transacciones.reduce((prev, curr) => prev + numeral(curr.monto).value(), 0);

    if (plain) {
      return numeral(saldo).value();
    } else if (saldo < 0) {
      return (
        <span style={{ color: 'red' }}>
          <b>{numeral(saldo).format('(0,0.00)')}</b>
        </span>
      );
    } else {
      return numeral(saldo).format('(0,0.00)');
    }
  }

  toggleReportOutline = (resumenAImprimir = null) => {
    this.setState({
      reportLayout: !this.state.reportLayout,
      resumenAImprimir
    }, () => {
      if (this.state.reportLayout) {
        this.findPrestamos(window.print);
      }
    });
  }

  findCuentas = () => {
    this.setState({
      cuentas: {
        ...this.state.cuentas,
        loading: true
      }
    }, () => {
      this.CuentaService.find()
        .then(response => {
          this.setState({
            cuentas: {
              ...this.state.cuentas,
              loading: true,
              data: response
            },
            upsertModal: {
              ...this.state.upsertModal,
              values: {
                ...this.state.upsertModal.values,
                cuentas: response.map((cuenta) => ({
                  concepto: cuenta.concepto,
                  monto: 0
                }))
              }
            }
          });
        })
        .catch(error => {
          this.setState({
            ...this.state.cuentas,
            loading: false,
            error
          });
        });
    });

  }

  findPrestamos = (callback) => {
    let { form } = this.state;

    this.setState({
      prestamos: {
        ...this.state.prestamos,
        loading: true
      }
    }, () => {
      this.PrestamoService.find({ query: { simple: true, sinCuotas: true }})
        .then((response) => {
          console.log(response);
          this.setState({
            prestamos: {
              ...this.state.prestamos,
              loading: false,
              data: response.records
            }
          }, () => {
            if (typeof callback === 'function') {
              callback();
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.setState({
            prestamos: {
              ...this.state.prestamos,
              loading: false,
              error
            }
          });
        });
    });
  }

  findResumenes = () => {
    let { resumenes } = this.state;

    this.setState({
      resumenes: {
        ...resumenes,
        loading: true
      }
    }, () => {
      this.ResumenService.find()
        .then(response => {
          console.log(response);
          this.setState({
            resumenes: {
              ...resumenes,
              data: response,
              loading: false
            }
          });
        })
        .catch(error => {
          this.setState({
            resumenes: {
              ...resumenes,
              error,
              loading: false
            }
          });
        });
    });
  }

  openUpsertModal = (cuenta) => {
    if (cuenta) {
      this.setState({
        upsertModal: {
          ...this.state.upsertModal,
          open: true,
          id: cuenta.id,
          values: {
            fecha: moment(cuenta.fecha).format('YYYY-MM-DD'),
            cuentas: cuenta.cuentas,
            ingresos: cuenta.ingresos,
            egresos: cuenta.egresos,
            recupero: cuenta.recupero
          }
        },
        prestamos: INITIAL_STATE.prestamos
      });
    } else {
      this.setState({
        upsertModal: {
          ...this.state.upsertModal,
          open: true
        }
      });
    }
  }

  dissmissUpsertModal = () => {
    this.setState({
      upsertModal: INITIAL_STATE.upsertModal
    });
  }

  upsertResumen = () => {
    let { upsertModal } = this.state;
    let values = {
      ...upsertModal.values,
      saldoInicial: numeral(upsertModal.values.saldoInicial).value()
    };

    this.setState({
      upsertModal: {
        ...upsertModal,
        loading: true
      }
    }, () => {
      if (upsertModal.id) {
        this.ResumenService.patch(upsertModal.id, values)
          .then(response => {
            this.setState({
              upsertModal: INITIAL_STATE.upsertModal
            }, () => {
              this.findResumenes();
            });
          })
          .catch(error => {
            this.setState({
              upsertModal: {
                ...upsertModal,
                error
              }
            });
          });
      } else {
        this.ResumenService.create(values)
          .then(response => {
            this.setState({
              upsertModal: INITIAL_STATE.upsertModal
            }, () => {
              this.findResumenes();
            });
          })
          .catch(error => {
            this.setState({
              upsertModal: {
                ...upsertModal,
                error
              }
            });
          });
      }
    });
  }

  openRemoveModal = (record) => {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        open: true,
        record
      }
    });
  }

  dismissRemoveModal = () => {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  removeRecord = () => {
    let { removeModal } = this.state;

    if (removeModal.loading) {
      return;
    }

    this.setState({
      removeModal: {
        ...removeModal,
        loading: true,
        error: null
      }
    }, () => {
      this.ResumenService.remove(removeModal.record.id)
        .then(response => {
          this.setState({
            removeModal: INITIAL_STATE.removeModal
          }, () => {
            this.findResumenes();
          });
        })
        .catch(error => {
          this.setState({
            removeModal: {
              ...removeModal,
              error
            }
          });
        });
    });
  }

  formInputHandler = (e, input) => {
    let { upsertModal } = this.state;
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === 'checkbox') {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState({
      upsertModal: {
        ...upsertModal,
        values: {
          ...upsertModal.values,
          [name]: value
        }
      }
    });
  }

  renderEditable = (datasetName, type = 'number', options) => (cellInfo) => {
    let {
      upsertModal: {
        values: {
          [datasetName]: dataset
        }
      }
    } = this.state;

    if (type === 'select') {
      return (
        <select style={{ padding: 0 }}>
          <option value="">-- Elija una opcion --</option>
          {
            this.state.cuentas.data.map((cuenta, index) => (
              <option key={index} value={cuenta.id}>{cuenta.concepto}</option>
            ))
          }
        </select>
      );
    } else {
      return (
        <div
          style={{ backgroundColor: "#fafafa", textAlign: (type === 'number') ? 'right' : 'left' }}
          contentEditable
          suppressContentEditableWarning
          onBlur={e => {
            if (type === 'number') {
              const data = [...dataset];
              let value = e.target.innerHTML;

              data[cellInfo.index][cellInfo.column.id] =
                numeral(value) ?
                  numeral(value).format('0,0.00') : '$0.00';

              this.setState({ data });
            } else {
              const data = [...dataset];
              let value = e.target.innerHTML;
              data[cellInfo.index][cellInfo.column.id] = value;
              this.setState({ data });
            }
          }}
          dangerouslySetInnerHTML={{
            __html: dataset[cellInfo.index][cellInfo.column.id]
          }} />
      );
    }
  }

  componentDidMount () {
    this.findResumenes();
    this.findCuentas();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    const { cuentas, resumenes, prestamos, upsertModal, removeModal, resumenAImprimir, reportLayout } = this.state;
    let prestamosConPagos = [];
    let prestamosOtorgados = [];

    if ((upsertModal.open && upsertModal.values.fecha) || resumenAImprimir) {
      let fecha = '';

      if (upsertModal.open && upsertModal.values.fecha) {
        fecha = upsertModal.values.fecha;
      } else {
        fecha = resumenAImprimir.fecha;
      }

      prestamos.data.forEach(prestamo => {
        const montoPagos = prestamo.pagos.filter((pago) => {
          return moment(pago.fecha).isSame(fecha, 'month');
        }).reduce((prev, curr) => {
          return prev + this.calcultarSaldo(curr.transacciones, true);
        }, 0);

        if (montoPagos !== 0) {
          prestamosConPagos.push({
            ...prestamo,
            montoPagos
          });
        }

        if (moment(prestamo.fechaOtorgado).isSame(fecha, 'month')) {
          prestamosOtorgados.push(prestamo);
        }
      });
    }

    if (reportLayout && resumenAImprimir) {
      if (prestamos.loading) {
        return (
          <div>
            Calculando ingresos y egresos por prestamos al {moment(resumenAImprimir.fecha).format('DD/MM/YYYY')} ...
          </div>
        );
      } else {
        return (
          <div>
            <Button content="Volver" icon="chevron left" className="no-print" onClick={this.toggleReportOutline.bind(null)} />
            <Header>
              RESUMEN MENSUAL DEL MOVIMIENTO FINANCIERO AL {moment(resumenAImprimir.fecha).format('DD/MM [de] YYYY')}
            </Header>
            <Header>
              CUENTAS
            </Header>
            <Table basic="very" compact="very" size="small" striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Concepto</Table.HeaderCell>
                  <Table.HeaderCell>Monto</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  resumenAImprimir.cuentas.map((cuenta, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{cuenta.concepto}</Table.Cell>
                      <Table.Cell style={{ textAlign: 'right' }}>{numeral(cuenta.monto).format('(0,0.00)')}</Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
              <Table.Footer>
                {
                  (() => {
                    const result = numeral(resumenAImprimir.cuentas.reduce((prev, curr) => numeral(curr.monto).value() + prev, 0));

                    return (
                      <Table.Row>
                        <Table.HeaderCell colSpan={4} collapsing style={{ textAlign: 'right' }}>
                          <span style={{ color: result.value() < 0 ? 'red' : 'grey' }}>
                            <strong>{result.format('(0,0.00)')}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()
                }
              </Table.Footer>
            </Table>
            <Header>
              INGRESOS
            </Header>
            <Table basic="very" compact="very" size="small" striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Concepto</Table.HeaderCell>
                  <Table.HeaderCell>Monto</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  resumenAImprimir.ingresos.map((ingreso, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{ingreso.nombre}</Table.Cell>
                      <Table.Cell style={{ textAlign: 'right' }}>{numeral(ingreso.monto).format('(0,0.00)')}</Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
              <Table.Footer>
                {
                  (() => {
                    const result = numeral(resumenAImprimir.ingresos.reduce((prev, curr) => numeral(curr.monto).value() + prev, 0));

                    return (
                      <Table.Row>
                        <Table.HeaderCell colSpan={4} collapsing style={{ textAlign: 'right' }}>
                          <span style={{ color: result.value() < 0 ? 'red' : 'grey' }}>
                            <strong>{result.format('(0,0.00)')}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()
                }
              </Table.Footer>
            </Table>
            <Header>
              RECUPERO DE PRESTAMOS
            </Header>
            <Table basic="very" compact="very" size="small" striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Concepto</Table.HeaderCell>
                  <Table.HeaderCell>Monto</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  prestamosConPagos.map((prestamo, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{`${prestamo.cooperativa.nombre} P - ${prestamo.codigo || 'sin/C'}`}</Table.Cell>
                      <Table.Cell style={{ textAlign: 'right' }}>{numeral(prestamo.montoPagos).format('(0,0.00)')}</Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
              <Table.Footer>
                {
                  (() => {
                    const result = numeral(prestamosConPagos.reduce((prev, curr) => numeral(curr.montoPagos).value() + prev, 0));

                    return (
                      <Table.Row>
                        <Table.HeaderCell colSpan={4} collapsing style={{ textAlign: 'right' }}>
                          <span style={{ color: result.value() < 0 ? 'red' : 'grey' }}>
                            <strong>{result.format('(0,0.00)')}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()
                }
              </Table.Footer>
            </Table>
            <Header>
              EGRESOS - PRESTAMOS Y SUBSIDIOS PAGADOS
            </Header>
            <Table basic="very" compact="very" size="small" striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Concepto</Table.HeaderCell>
                  <Table.HeaderCell>Monto</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  prestamosOtorgados.map((prestamo, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{`${prestamo.cooperativa.nombre} P - ${prestamo.codigo || 'sin/C'}`}</Table.Cell>
                      <Table.Cell style={{ textAlign: 'right' }}>{prestamo.monto}</Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
              <Table.Footer>
                {
                  (() => {
                    const result = numeral(prestamosOtorgados.reduce((prev, curr) => numeral(curr.monto).value() + prev, 0));

                    return (
                      <Table.Row>
                        <Table.HeaderCell colSpan={4} collapsing style={{ textAlign: 'right' }}>
                          <span style={{ color: result.value() < 0 ? 'red' : 'grey' }}>
                            <strong>{result.format('(0,0.00)')}</strong>
                          </span>
                        </Table.HeaderCell>
                      </Table.Row>
                    );
                  })()
                }
              </Table.Footer>
            </Table>
          </div>
        );
      }
    }

    return (
      <div>
        <Segment clearing>
          <Button content="Refresh" icon="refresh" disabled={resumenes.loading} positive onClick={this.findResumenes} />
          <Button content="Nuevo" icon="add" floated="right" disabled={resumenes.loading} primary onClick={this.openUpsertModal.bind(null, null)} />
        </Segment>
        {
          resumenes.error &&
          <Message negative>
            <Message.Header>{resumenes.error.name}</Message.Header>
            <p>{resumenes.error.message}</p>
          </Message>
        }
        <ReactTable
          className="-striped -highlight" loading={resumenes.loading}
          noDataText={'Sin Registros'} loadingText={'Cargando...'}
          defaultPageSize={3}
          data={resumenes.data}
          previousText={'<<<'} nextText={'>>>'}
          pageText={'Pagina'} ofText={'de'} rowsText={'filas'}
          columns={[
            {
              Header: '',
              width: 48,
              Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  <Button icon="edit" onClick={this.openUpsertModal.bind(null, row.original)} size="mini" />
                </div>
              ),
              sortable: false,
              resizable: false
            },
            {
              Header: '',
              width: 128,
              Cell: ({ original: resumen }) => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  <Button content="Reporte" icon="file" onClick={this.toggleReportOutline.bind(null, resumen)} secondary size="mini" />
                </div>
              ),
              sortable: false,
              resizable: false
            },
            {
              Header: 'Fecha de Resumen',
              id: 'fecha',
              Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  {moment(row.original.fecha).parseZone().format('DD/MM/YYYY')}
                </div>
              ),
              sortable: false,
              resizable: false
            },
            {
              Header: '',
              width: 32,
              Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                  <Icon
                    color="red"
                    className="trash-icon-hover" name="trash"
                    onClick={this.openRemoveModal.bind(null, row.original)} />
                </div>
              ),
              sortable: false,
              resizable: false
            }
          ]} />
        <Modal
          closeOnDimmerClick={false} closeOnEscape={false}
          size="large" open={upsertModal.open} onClose={this.dissmissUpsertModal}>
          <Modal.Header>{upsertModal.id ? 'Modificacion' : 'Alta'} de Resumen</Modal.Header>
          <Modal.Content >
            <Form>
              <Form.Group>
                <Form.Input
                  name="fecha" label="Fecha" type="date"
                  value={upsertModal.values.fecha}
                  onChange={this.formInputHandler} />
              </Form.Group>
              <ReactTable
                data={upsertModal.values.cuentas}
                className="-striped -highlight" loading={resumenes.loading}
                noDataText={'Sin Registros'} loadingText={'Cargando...'}
                previousText={'<<<'} nextText={'>>>'}
                pageText={'Pagina'} ofText={'de'} rowsText={'filas'}
                defaultPageSize={upsertModal.values.cuentas.length} showPagination={false}
                columns={[
                  {
                    Header: 'Cuentas',
                    columns: [
                      {
                        Header: 'Concepto',
                        accessor: 'concepto'
                      },
                      {
                        Header: 'Monto',
                        accessor: 'monto',
                        Cell: this.renderEditable('cuentas', 'number')
                      }
                    ]
                  }
                ]} />
              <ReactTable
                data={upsertModal.values.ingresos}
                className="-striped -highlight" loading={resumenes.loading}
                noDataText={'Sin Registros'} loadingText={'Cargando...'}
                previousText={'<<<'} nextText={'>>>'}
                pageText={'Pagina'} ofText={'de'} rowsText={'filas'}
                defaultPageSize={upsertModal.values.ingresos.length} showPagination={false}
                columns={[
                  {
                    Header: 'Ingresos',
                    columns: [
                      {
                        Header: 'Concepto',
                        accessor: 'nombre'
                      },
                      {
                        Header: 'Monto',
                        accessor: 'monto',
                        Cell: this.renderEditable('ingresos', 'number')
                      }
                    ]
                  }
                ]} />
              <Button
                disabled={prestamos.loading}
                style={{ marginTop: 16, marginBottom: 16 }}
                primary fluid
                content={
                  prestamos.loading ?
                    'Cargando...' :
                    `Calcular Ingresos/Egresos por prestamos a la fecha (${moment(upsertModal.values.fecha).format('MM - YYYY')})`
                } onClick={this.findPrestamos} />
              {
                (prestamos.data.length !== 0) &&
                  <ReactTable
                    className="-striped -highlight" loading={prestamos.loading}
                    noDataText={'Sin Registros'} loadingText={'Cargando...'}
                    defaultPageSize={prestamosConPagos.length || 4} pageSizeOptions={[prestamosConPagos.length || 4]}
                    showPagination={false}
                    data={prestamosConPagos}
                    columns={[
                      {
                        Header: 'Recuperos',
                        columns: [
                          {
                            Header: 'Concepto',
                            id: 'concepto',
                            accessor: prestamo => `${prestamo.cooperativa.nombre} P - ${prestamo.codigo || 'sin/C'}`
                          },
                          {
                            Header: 'Recupero',
                            id: 'recupero',
                            Cell: ({ original: prestamo }) => {
                              return (
                                <div
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    textAlign: 'right'
                                  }}>
                                  <div
                                    style={{
                                      width: `100%`,
                                      height: '100%'
                                    }}>
                                    <span>
                                      <strong>{numeral(prestamo.montoPagos).format('(0,0.00)')}</strong>
                                    </span>
                                  </div>
                                </div>
                              );
                            },
                            width: 128,
                            sortable: false
                          }
                        ]
                      }
                    ]} />
              }
              {
                (prestamos.data.length !== 0) &&
                  <ReactTable
                    className="-striped -highlight" loading={prestamos.loading}
                    noDataText={'Sin Registros'} loadingText={'Cargando...'}
                    defaultPageSize={prestamosOtorgados.length || 4} pageSizeOptions={[prestamosOtorgados.length || 4]}
                    showPagination={false}
                    data={prestamosOtorgados}
                    columns={[
                      {
                        Header: 'Prestamos Otorgados',
                        columns: [
                          {
                            Header: 'Concepto',
                            id: 'concepto',
                            accessor: prestamo => `${prestamo.cooperativa.nombre} P - ${prestamo.codigo || 'sin/C'}`
                          },
                          {
                            Header: 'Monto',
                            id: 'monto',
                            Cell: ({ original: prestamo }) => {
                              return (
                                <div
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    textAlign: 'right'
                                  }}>
                                  <div
                                    style={{
                                      width: `100%`,
                                      height: '100%'
                                    }}>
                                    <span>
                                      <strong>{numeral(prestamo.monto).format('(0,0.00)')}</strong>
                                    </span>
                                  </div>
                                </div>
                              );
                            },
                            width: 128,
                            sortable: false
                          }
                        ]
                      }
                    ]} />
              }
            </Form>
            {
              upsertModal.error &&
              <Message negative>
                <Message.Header>{upsertModal.error.name}</Message.Header>
                <p>{upsertModal.error.message}</p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button negative basic content="Cancelar" icon="remove" onClick={this.dissmissUpsertModal} />
            <Button positive content="Aceptar" icon="checkmark" onClick={this.upsertResumen} />
          </Modal.Actions>
        </Modal>
        <Modal dimmer="blurring" basic size="small" open={removeModal.open} onClose={this.dismissRemoveModal}>
          <Modal.Header icon="trash">Eliminar Cuenta</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              Seguro desea eliminar la cuenta?
            </Modal.Description>
            {
              removeModal.error &&
              <Message negative>
                <Message.Header>{removeModal.error.name}</Message.Header>
                <p>{removeModal.error.message}</p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button basic negative inverted onClick={this.dismissRemoveModal} disabled={removeModal.loading}>
              <Icon name="remove" /> No
            </Button>
            <Button positive onClick={this.removeRecord} disabled={removeModal.loading}>
              <Icon name="checkmark" /> {removeModal.loading ? 'Eliminando' : 'Si'}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    MensualView.mapStateToProps,
    MensualView.mapDispatchToProps
  )(MensualView)
);



// WEBPACK FOOTER //
// ./client/components/pages/financiero/MensualView.js